export default ({ FONT_SIZES, COLORS }) => ({
  noParents: {
    margin: '30px 0',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  }
})
